import React, { useState } from 'react';
import { useComponentVisible } from '../_hooks';
import './Multiselect.css';
var Type;
(function (Type) {
    Type[Type["Deselect"] = 0] = "Deselect";
    Type[Type["Select"] = 1] = "Select";
})(Type || (Type = {}));
var Multiselect = function (props) {
    var options = props.options, selectedOptions = props.selectedOptions, onSelect = props.onSelect;
    var _a = useComponentVisible(false), parentRef = _a.parentRef, toggleRef = _a.toggleRef, isVisible = _a.isVisible, setIsVisible = _a.setIsVisible;
    var _b = useState(null), highlightedOption = _b[0], setHighlightedOption = _b[1];
    var handleSelect = function (type, option, nativeEvent) {
        if (type === Type.Deselect)
            setIsVisible(false);
        onSelect && onSelect(option, nativeEvent);
    };
    var getMultiselectOptionClass = function (option) {
        var className = ['multiselect__option'];
        if (highlightedOption && highlightedOption.value === option.value)
            className.push('multiselect__option--highlight');
        if (selectedOptions &&
            selectedOptions.find(function (o) { return o.value === option.value; })) {
            className.push('multiselect__option--selected');
        }
        return className.join(' ');
    };
    return (React.createElement("div", { ref: parentRef, tabIndex: 0, className: "multiselect" + (isVisible ? ' multiselect--active' : '') },
        React.createElement("div", { ref: toggleRef, className: "multiselect__select" }),
        React.createElement("div", { className: "multiselect__tags" },
            React.createElement("div", { className: "multiselect__tags-wrap" }, selectedOptions &&
                selectedOptions.length > 0 &&
                selectedOptions.map(function (option, index) { return (React.createElement("span", { key: index, className: "multiselect__tag" },
                    React.createElement("span", null,
                        option.text,
                        "\u00A0"),
                    React.createElement("i", { "aria-hidden": "true", tabIndex: 1, className: "multiselect__tag-icon", onClick: function (nativeEvent) {
                            return handleSelect(Type.Deselect, option, nativeEvent);
                        } }))); }))),
        isVisible ? (React.createElement("div", { tabIndex: -1, className: "multiselect__content-wrapper" },
            React.createElement("ul", { className: "multiselect__content", style: { display: 'inline-block' } }, options &&
                options.length > 0 &&
                options.map(function (option, index) { return (React.createElement("li", { key: index, className: "multiselect__element", onClick: function (nativeEvent) {
                        return handleSelect(Type.Select, option, nativeEvent);
                    }, onMouseEnter: function () {
                        return setHighlightedOption(option);
                    } },
                    React.createElement("span", { "data-select": "", "data-selected": "Selected", "data-deselect": "", className: getMultiselectOptionClass(option) },
                        React.createElement("span", null, option.text)))); })))) : null));
};
export default React.memo(Multiselect);
